import { render, staticRenderFns } from "./IndexHome.vue?vue&type=template&id=ebd0e8e2&lang=pug&"
import script from "./IndexHome.vue?vue&type=script&lang=js&"
export * from "./IndexHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports